import React, { useEffect, useState } from 'react';
import './landingPageStyle.css';
import { IoIosArrowRoundDown } from 'react-icons/io';
import { FaShieldAlt, FaMobileAlt, FaGlobeAfrica, FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import ParticlesBg from './ParticlesBg';
import clbs from './landing-images/clbs.jpg';
import secureme from './landing-images/secureme.png';
import ogaApp from './landing-images/ogaApp.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LandingHeader from './landing-header/LandingHeader';

const LandingPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <LandingHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <section className="hero" id="hero">
        <div className="hero-overlay" />
        <ParticlesBg />
        <div className="hero-content" data-aos="fade-up">
          <span className="hero-badge">Vitel Wireless: Everything connected</span>
          <h1 className="hero-title">
            <span className="hero-title-highlight">VITEL WIRELESS</span> LIMITED
          </h1>
          <p className="hero-subtitle">
            Unifying communication using GSM Numbers + VoIP + IoT + VAS
          </p>
          <div className="hero-actions">
            <a href="#services" className="btn-primary">
              Get Started <FaArrowRight className="btn-icon" />
            </a>
            <a href="#coverage" className="btn-outline">
              Learn More
            </a>
          </div>
        </div>
        <div className="hero-scroll" data-aos="fade-down" data-aos-delay="500">
          <span className="scroll-text">Scroll</span>
          <IoIosArrowRoundDown className="scroll-arrow" />
        </div>
      </section>

      <section className="services" id="services">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">Our Solutions</span>
            <h2 className="section-title">Platforms We Power</h2>
            <p className="section-desc">
              Cutting-edge telecommunication and location-based solutions
              designed to drive your business forward.
            </p>
          </div>

          <div className="services-grid">
            <div className="service-card" data-aos="fade-up" data-aos-delay="0">
              <a href="/secureme-app" className="service-card-link">
                <div className="service-img-wrapper">
                  <img src={secureme} alt="Secure Me" />
                </div>
                <div className="service-body">
                  <h3 className="service-name">Secure Me</h3>
                  <p className="service-desc">
                    Advanced security and surveillance solutions to protect what matters most.
                  </p>
                  <span className="service-cta">
                    Explore <FaArrowRight className="cta-icon" />
                  </span>
                </div>
              </a>
            </div>

            <div className="service-card" data-aos="fade-up" data-aos-delay="150">
              <a href="/oga-app" className="service-card-link">
                <div className="service-img-wrapper">
                  <img src={ogaApp} alt="OGA App" />
                </div>
                <div className="service-body">
                  <h3 className="service-name">OGA App</h3>
                  <p className="service-desc">
                    Comprehensive device management and tracking platform for your workforce.
                  </p>
                  <span className="service-cta">
                    Explore <FaArrowRight className="cta-icon" />
                  </span>
                </div>
              </a>
            </div>

            <div className="service-card" data-aos="fade-up" data-aos-delay="300">
              <a href="/login" className="service-card-link">
                <div className="service-img-wrapper">
                  <img src={clbs} alt="CLBS" />
                </div>
                <div className="service-body">
                  <h3 className="service-name">CLBS</h3>
                  <p className="service-desc">
                    Location-based services platform for accurate positioning and navigation.
                  </p>
                  <span className="service-cta">
                    Explore <FaArrowRight className="cta-icon" />
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="features" id="features">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">Why Choose Us</span>
            <h2 className="section-title">Built for Reliability</h2>
          </div>
          <div className="features-grid">
            <div className="feature-item" data-aos="fade-up" data-aos-delay="0">
              <div className="feature-icon"><FaGlobeAfrica /></div>
              <h4>Nationwide Coverage</h4>
              <p>Reliable connectivity across all regions with our robust infrastructure.</p>
            </div>
            <div className="feature-item" data-aos="fade-up" data-aos-delay="100">
              <div className="feature-icon"><FaShieldAlt /></div>
              <h4>Enterprise Security</h4>
              <p>Bank-grade encryption and security protocols to keep your data safe.</p>
            </div>
            <div className="feature-item" data-aos="fade-up" data-aos-delay="200">
              <div className="feature-icon"><FaMobileAlt /></div>
              <h4>Real-Time Tracking</h4>
              <p>Live device tracking and monitoring with instant alerts and reporting.</p>
            </div>
            <div className="feature-item" data-aos="fade-up" data-aos-delay="300">
              <div className="feature-icon"><FaCheckCircle /></div>
              <h4>24/7 Support</h4>
              <p>Dedicated support team available around the clock to assist you.</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>Vitel Wireless</h3>
              <p>Unifying communication using GSM Numbers + VoIP + IoT + VAS</p>
            </div>
            <div className="footer-contact">
              <p>For support and enquiry call: <strong>2347120000071</strong></p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Vitel Wireless Limited. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default LandingPage;
